import styled from '@emotion/styled'

export const FormInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`
